/** Conteúdo inicial quando ainda não há versão persistida (texto simples / markdown leve). */

/** Versão editorial usada quando ainda não existe documento em `AppContent`. */
export const LEGAL_DOCUMENT_DEFAULT_VERSION_NUMBER = 1;

export const LEGAL_DOCUMENT_DEFAULT_TERMS = `TERMOS DE USO — RETORNAAR

1. Disposições gerais
1.1. Estes termos regem o uso do sistema RetornaAr pelos usuários cadastrados.
1.2. Ao utilizar o serviço, você declara ter lido e concordado com estas condições.

2. Uso do sistema
2.1. O conteúdo e as funcionalidades são destinados ao uso profissional conforme o plano contratado.
2.2. É vedado o uso que viole a legislação aplicável ou prejudique terceiros.

3. Alterações
3.1. Podemos atualizar estes termos; a versão vigente será sempre a publicada nesta área administrativa.

---
Documento modelo. Edite ou crie uma nova versão pelo painel.`;

export const LEGAL_DOCUMENT_DEFAULT_PRIVACY = `POLÍTICA DE PRIVACIDADE — RETORNAAR

1. Dados que tratamos
1.1. Dados de cadastro, operação do serviço e comunicações relacionadas ao produto.

2. Finalidades
2.1. Prestação do serviço, suporte, melhorias e cumprimento de obrigações legais.

3. Direitos do titular
3.1. Nos termos da LGPD, você pode solicitar acesso, correção ou exclusão de dados quando aplicável.

---
Documento modelo. Edite ou crie uma nova versão pelo painel.`;
